import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";

import {gpCommon} from "../GasPass";
import {Query} from "../libs/Query";


let controllerQuestionFormUpdateInterval = null;
let controllerQuestionFormUpdateInProgress = false;

const ControllerQuestionForm = ({ data, setData, setPopup, setNavigation, setMenu }) => {

    useEffect( () => {

        return () => {
            if( controllerQuestionFormUpdateInterval !== null ) {
                clearInterval( controllerQuestionFormUpdateInterval );
                controllerQuestionFormUpdateInterval = null;
            }
            controllerQuestionFormUpdateInProgress = false;
        }

    }, [] );

    useEffect( () => {

        let updateRequired = false;
        if( gpCommon.getObject( data, null ) !== null ) {
            let updateUrl = gpCommon.getString( data['update'], null );
            if( updateUrl !== null ) {
                updateRequired = true;
            }
        }

        if( updateRequired ) {
            // Update required
            if( controllerQuestionFormUpdateInterval === null ) {
                controllerQuestionFormUpdateInterval = setInterval( onUpdateTimeout, 10000 );
            }

        }
        else {
            // Update no more required
            if( controllerQuestionFormUpdateInterval !== null ) {
                clearInterval( controllerQuestionFormUpdateInterval );
                controllerQuestionFormUpdateInterval = null;
            }
            controllerQuestionFormUpdateInProgress = false;
        }

    }, [data] );


    return(
        <center>
            <table className="questionForm">
                {gpCommon.getString( data['title'], null ) !== null && <thead>
                    <tr>
                        <th>{gpCommon.getString( data['title'], '' )}</th>
                    </tr>
                </thead>}
                {( ( gpCommon.getString( data['description'], null ) !== null ) || ( gpCommon.getArray( data['button'], null ) !== null ) ) && <tbody>
                    {gpCommon.getString( data['description'], null ) !== null && <tr>
                        <td className="description">{gpCommon.getString( data['description'], '' )}</td>
                    </tr>}

                    {gpCommon.getArray( data['button'], null ) !== null && <tr><td><div className="bottomButtons">
                        {gpCommon.getArray( data['button'], [] ).map( ( button ) => {
                            return (
                                <input key={gpCommon.getString( button['id'], '' )} type="button" value={gpCommon.getString( button['value'], '' )} onClick={( e ) => onClickButton( button )} />
                            );
                        })}
                    </div></td></tr>}
                </tbody>}
            </table>
        </center>
    );

    function onClickButton( button ) {
        let buttonAction = gpCommon.getString( button['action'], null );
        if( buttonAction === 'submit' ) {
            // Submit action
            let submitUrl = gpCommon.getString( button['url'], null );
            if( submitUrl !== null ) {

                new Query().get( submitUrl, { action: 'submit' }, ( response ) => {
                    //
                    let responseStatus = gpCommon.getString( response['status'], '' );
                    if( responseStatus === 'ok' ) {
                        // Successful
                        if( typeof response['data'] != "undefined" ) {
                            let data = gpCommon.getObject( response['data'], null );
                            setData( data );
                        }

                        if( typeof response['popup'] != "undefined" ) {
                            let popup = gpCommon.getObject( response['popup'], null );
                            setPopup( popup );
                        }

                        if( typeof response['menu'] != "undefined" ) {
                            let menuData = gpCommon.getArray( response['menu'], null );
                            setMenu( menuData );
                        }

                        if( typeof response['navigation'] != "undefined" ) {
                            let navigation = gpCommon.getArray( response['navigation'], null );
                            setNavigation( navigation );
                        }

                    }

                }, ( error ) => {
                    //
                    if( error.message === 'Not found' )
                    {
                        setData({
                            type: 'notFound',
                            code: '404',
                            description: 'Указанная страница не найдена'
                        })
                    }
                    else if( error.message === 'No response' )
                    {
                        setData({
                            type: 'notFound',
                            code: '408',
                            description: 'Не получен ответ при выполнении запроса'
                        })
                    }
                    else {
                        setData({
                            type: 'notFound',
                            code: '500',
                            description: 'Внутренняя ошибка при выполнении запроса'
                        })
                    }
                    setPopup( null );
                });
            }

        }
        else if( buttonAction === 'link' ) {
            // Open link
            let linkUrl = gpCommon.getString( button['url'], null );
            if( linkUrl !== null ) {
                window.open( new Query().LINK_URL + linkUrl, '_blank' );
            }

        }
        else if( buttonAction === 'close' ) {
            setPopup( null );
        }
    }

    function onUpdateTimeout( e ) {
        if( !controllerQuestionFormUpdateInProgress ) {
            if( gpCommon.getObject( data, null ) !== null ) {
                let updateUrl = gpCommon.getString( data['update'], null );
                if( updateUrl !== null ) {

                    controllerQuestionFormUpdateInProgress = true;

                    new Query().get( updateUrl, {}, ( response ) => {
                        //
                        let responseStatus = gpCommon.getString( response['status'], '' );
                        if( responseStatus === 'ok' ) {
                            // Successful
                            if( typeof response['data'] != "undefined" ) {
                                let data = gpCommon.getObject( response['data'], null );
                                setData( data );
                            }

                            if( typeof response['popup'] != "undefined" ) {
                                let popup = gpCommon.getObject( response['popup'], null );
                                setPopup( popup );
                            }

                            if( typeof response['menu'] != "undefined" ) {
                                let menuData = gpCommon.getArray( response['menu'], null );
                                setMenu( menuData );
                            }

                            if( typeof response['navigation'] != "undefined" ) {
                                let navigation = gpCommon.getArray( response['navigation'], null );
                                setNavigation( navigation );
                            }

                        }

                        controllerQuestionFormUpdateInProgress = false;

                    }, ( error ) => {
                        //
                        if( error.message === 'Not found' )
                        {
                            setPopup( null );
                        }

                        controllerQuestionFormUpdateInProgress = false;
                    });

                }
            }
        }
    }

}
ControllerQuestionForm.propTypes = {
    data: PropTypes.object.isRequired,
    setData: PropTypes.func.isRequired,
    setPopup: PropTypes.func.isRequired,
    setNavigation: PropTypes.func.isRequired,
    setMenu: PropTypes.func.isRequired
};
export default ControllerQuestionForm;
